import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux'

import { LOG_OUT } from '../actions/auth';

import currentUser from './currentUser';
import organisations from './organisations';
import profiles from './profiles';
import devices from './devices';
import events from './events';
import auth from './auth';

import uiReducers from './ui';

const appReducer = combineReducers({
  auth,
  currentUser,
  organisations,
  profiles,
  devices,
  events,
  ui: uiReducers,
  router: routerReducer
});

// reset all state on LOG_OUT
// (https://stackoverflow.com/questions/35622588/how-to-reset-the-state-of-a-redux-store)
const rootReducer = (state, action) => {
  if(action.type === LOG_OUT) {
    state = undefined;
  }

  return appReducer(state, action);
}

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js